import React, { useState } from 'react';
import SolutionCalc from './components/solutionCalc/SolutionCalc';
import styled from 'styled-components';

import {
  Paper,
  MainTitle,
  MainCalWrapper,
  MainCalc,
  MainInput,
  MainActions,
  MainLabel,
  Hr,
} from './styled/stylezz';

const CircleBall = styled.div`
  &&& {
    position: relative;
    display: block;
    background: black;
    border-radius: 100%;
    height: 150px;
    width: 150px;
    margin: 0;
    background: radial-gradient(circle at 50px 50px, #5cabff, #000);
  }
`;

const CircleIn = styled.div`
  &&& {
    position: absolute;
    top: 50%;
    width: 98%;
    height: 75px;
    background: #777777;
    border-top: 1px dashed white;
    border-bottom: 2px solid white;
    border-radius: 75px/37px;
    transform: translateY(-50%);
    overflow: hidden;
    opacity: 0.5;
    &:after {
      content: 'R';
      color: white;
      width: 50%;
      height: 2px;
      background-color: white;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%);
      transform-origin: left;
      transform: rotate(25deg);
    }
  }
`;

const App = () => {
  const [inputR, setInputR] = useState('');
  const [solutionShow, setSolutionShow] = useState(false);

  const handleSolution = () => {
    setSolutionShow(true);
  };

  const handleCleanInput = () => {
    setInputR('');

    setSolutionShow(false);
  };
  return (
    <React.Fragment>
      <Paper>
        <MainTitle>Калькулятор</MainTitle>
        <MainCalWrapper>
          <span style={{ fontSize: '20px' }}>Введите данные:</span>
          <Hr />

          <MainCalc>
            <MainLabel>
              R=
              <MainInput
                type="text"
                value={inputR}
                onChange={(e) =>
                  setInputR(e.target.value.replace(/[^\d\-.]|\b-/, ''))
                }
              ></MainInput>
            </MainLabel>
            <CircleBall>
              <CircleIn />
            </CircleBall>
          </MainCalc>
          <Hr />

          <MainActions>
            <button onClick={handleSolution}>Решение</button>
            <button onClick={handleCleanInput}>Сбросить</button>
          </MainActions>
        </MainCalWrapper>

        {solutionShow && <SolutionCalc R={+inputR} />}
      </Paper>
    </React.Fragment>
  );
};

export default App;
